// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PhotosUploadScreen":"qo_a bhy_ea bhy_qt bhy_a bhy_w"};